import { render, staticRenderFns } from "./AscUserManagementTemplate.vue?vue&type=template&id=5539f429&"
import script from "./AscUserManagementTemplate.vue?vue&type=script&lang=js&"
export * from "./AscUserManagementTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports